import { render, staticRenderFns } from "./marketList.vue?vue&type=template&id=b84a291e&scoped=true&"
import script from "./marketList.vue?vue&type=script&lang=js&"
export * from "./marketList.vue?vue&type=script&lang=js&"
import style0 from "./marketList.vue?vue&type=style&index=0&id=b84a291e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84a291e",
  null
  
)

export default component.exports